// pfs-row.ts — horizontaler gap-Container (PFS-652 Spacing-System).
//
// Generisches Layout-Primitive: reiht Kinder horizontal mit gap, bricht bei
// Bedarf um (Cluster). Für Actions/Toolbars/Inline-Gruppen. KEIN margin.
// data-gap wählt den Skalen-Schritt (Default: action); data-align steuert die
// horizontale Verteilung (justify-content), data-valign die Kreuz-Achse
// (align-items, Default center).
//
//   <pfs-row data-gap="action" data-align="end"> <button/> <button/> </pfs-row>
//
// data-collapse (PFS-660): intrinsisch responsiv — bei schmalem Container
// wird die Reihe zur Spalte mit full-width Kindern (align-items:stretch).
// Braucht einen container-type-Vorfahren; ohne einen bleibt es eine Reihe
// (graceful). Gleiche Mechanik wie <pfs-field> (Container-Query quert Shadow).
import { defineComponent } from "../../composition/define-component.js";
import { withShadow } from "../../composition/with-shadow.js";

const STYLES = `
:host { display: flex; flex-wrap: wrap; align-items: center; gap: var(--pfs-space-action, 0.5rem); }
:host([data-gap="section"]) { gap: var(--pfs-space-section, 1rem); }
:host([data-gap="field"]) { gap: var(--pfs-space-field, 0.75rem); }
:host([data-gap="label"]) { gap: var(--pfs-space-label, 0.5rem); }
:host([data-gap="action"]) { gap: var(--pfs-space-action, 0.5rem); }
:host([data-align="start"]) { justify-content: flex-start; }
:host([data-align="end"]) { justify-content: flex-end; }
:host([data-align="between"]) { justify-content: space-between; }
:host([data-align="center"]) { justify-content: center; }
/* data-valign steuert die Kreuz-Achse (align-items). Default center; start =
   Titel+Aktionen oben-bündig (löst .headerbar/.item-head flex-start ab, PFS-661). */
:host([data-valign="start"]) { align-items: flex-start; }
:host([data-valign="center"]) { align-items: center; }
:host([data-valign="end"]) { align-items: flex-end; }
@container (max-width: 30rem) {
  :host([data-collapse]) { flex-direction: column; align-items: stretch; }
}
`;

defineComponent({
  tagName: "pfs-row",
  eager: true,
  mixins: [withShadow()],
  render(_host, ctx) {
    const root = ctx.shadowRoot;
    if (!root) return;
    const style = document.createElement("style");
    style.textContent = STYLES;
    root.append(style, document.createElement("slot"));
  },
});
